// @flow
import React from 'react'
import { Link } from 'react-router-dom'

export const IncorrectPassword = (): any => {
  return (
    <div className='login'>
      <span className='login__accent' />
      <div className='login__header'>
        <h3 className='login__title'>Incorrect credentials</h3>
        <h4 className='login__subtitle'>The credentials you submitted were incorrect. Please check the information you submitted and try again.</h4>
      </div>
      <Link to='/' className='login__link'>Return to Login Page</Link>
    </div>
  )
}

IncorrectPassword.displayName = 'IncorrectPassword'

export default IncorrectPassword
